module.exports = __webpack_public_path__ + "static/img/ico_s_technology@2x.a204e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_s_technology@2x.png
// module id = F4iS
// module chunks = 0